import { useState } from "react";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Radio,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Translate from "../../../utils/Translate";
import { Info, InfoOutlined } from "@mui/icons-material";

const ORIGINAL_OPTION_ID = "__original__";

function DetailsCard({ rows, selected, onSelect }) {
  const theme = useTheme();
  return (
    <Card
      onClick={onSelect}
      sx={{
        padding: "16px",
        transform: "translateZ(0)",
        borderRadius: "4px",
        cursor: "pointer",
        border: selected ? `2px solid ${theme.palette.primary.main}` : "2px solid transparent",
      }}
      style={{ boxShadow: theme.customShadows.z16 }}
    >
      <Stack direction="row" alignItems="flex-start" spacing={1.5}>
        <Radio checked={selected} sx={{ p: 0, mt: 0.25 }} />
        <Box sx={{ flex: 1 }}>
          <Grid container spacing={2} direction="column">
            {rows.map((row, idx) => (
              <Grid container key={idx} alignItems="center" gap={1.5}>
                {row.icon}
                <Box sx={{ color: row.value ? "text.primary" : "text.secondary" }}>{row.value || "—"}</Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Stack>
    </Card>
  );
}

export default function SelectActorMatchDialog({
  originalDetails,
  matches,
  selectedActorId,
  onSelect,
  onClose,
  getMatchDetails,
  isCompany,
}) {
  const [pickedId, setPickedId] = useState(selectedActorId ?? ORIGINAL_OPTION_ID);

  const handleSelect = () => {
    onSelect(pickedId === ORIGINAL_OPTION_ID ? undefined : pickedId);
  };

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth scroll="paper" className="tightMobileDialog">
      <DialogTitle>
        <Stack direction="row" alignItems="center">
          <Box>{Translate.get("PotentialMatches")}</Box>
          <Tooltip
            title={
              isCompany
                ? Translate.get("SelectActorMatchDescriptionCompany")
                : Translate.get("SelectActorMatchDescriptionPerson")
            }
            sx={{ marginLeft: "8px" }}
          >
            <Info color="primary" />
          </Tooltip>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
          <h4 style={{ marginTop: "12px", marginBottom: "16px" }}>{Translate.get("DetailsFromPreliminaryBooking")}</h4>
          <DetailsCard
            rows={originalDetails}
            selected={pickedId === ORIGINAL_OPTION_ID}
            onSelect={() => setPickedId(ORIGINAL_OPTION_ID)}
          />
          <h4 style={{ marginTop: "32px", marginBottom: "16px" }}>{Translate.get("PotentialMatchesFromRegister")}</h4>
          {matches.map((m) => (
            <DetailsCard
              key={m.actorId}
              rows={getMatchDetails(m)}
              selected={pickedId === m.actorId}
              onSelect={() => setPickedId(m.actorId)}
            />
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{Translate.get("Cancel")}</Button>
        <Button variant="contained" disabled={!pickedId} onClick={handleSelect}>
          {Translate.get("Select")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
